import { render } from "./GuiTinkoffPaymentStatusSelect.vue?vue&type=template&id=398c2f55"
import script from "./GuiTinkoffPaymentStatusSelect.vue?vue&type=script&lang=js"
export * from "./GuiTinkoffPaymentStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__